import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: calc(100dvh - 120px);
  margin: 1rem auto;
  background: #dfedff18;
  padding: 30px;
  backdrop-filter: blur(50px);

  @media (min-width: 640px) {
    max-width: 640px;
  }

  @media (min-width: 768px) {
    max-width: 768px;
  }

  @media (min-width: 1024px) {
    max-width: 1024px;
  }

  @media (min-width: 1280px) {
    max-width: 1280px;
  }

  @media (min-width: 1536px) {
    max-width: 1536px;
  }
`;
